import { defineSlotRecipe } from '@chakra-ui/react';

import { fieldSlots } from '../slots';

export default defineSlotRecipe({
  slots: fieldSlots,
  base: {
    requiredIndicator: {
      color: 'primary.500',
      _empty: {
        _before: {
          content: '"*"',
        },
      },
    },
    label: {
      display: 'block',
    },
    tooltipIcon: {
      alignItems: 'center',
      color: 'primary.500',
      display: 'inline-flex',
    },
  },
  defaultVariants: {
    sizes: 'md',
  },
  variants: {
    orientation: {
      vertical: {
        root: {
          alignItems: 'stretch',
        },
      },
    },
    sizes: {
      lg: {
        label: {
          fontSize: '2xl',
          fontWeight: 'bold',
          mb: 6,
        },
      },
      md: {
        label: {
          mb: 0,
        },
        errorText: {
          fontSize: 'sm',
        },
      },
    },
  },
});
